import {
    Component,
    OnInit,
    OnDestroy,
    Inject,
    Input,
    AfterViewInit,
    ViewChild
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromCJ_r from '../store/reducer';
import * as fromUser from '../../user-info/store/user.reducer';
import * as fromErrors from '../../shared';
import * as fromLookups from '../../lookups';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { DatePipe } from '@angular/common';
import { Process } from '../../shared';
import { combineLatest, Observable, ReplaySubject, Subscription } from 'rxjs';
import { IContractStructure } from '../IContractStructure';
import {
    LoadCustomerJobs,
    Reset,
    LoadEntityFilter,
    UpdateContractStructure,
    LoadCustomers
} from '../store/actions';
import { takeWhile, withLatestFrom, filter } from 'rxjs/operators';
import { IEntityFilter } from '../IEntityFilter';
import { ContractStructurePresentersComponent } from '../presenters/contract-structure-presenters.component';
import { ICustomer } from '../ICustomer';
import { IShowErrors } from '../../shared/errors-sidenav';
import * as fromShared from '../../shared';

@Component({
    selector: 'ef-contract-structure-features',
    templateUrl: './contract-structure-features.component.html',
    styleUrls: ['./contract-structure-features.component.scss'],
    standalone: false
})
export class ContractStructureFeaturesComponent
    implements OnInit, OnDestroy, AfterViewInit {
    private lookupsSub: Subscription;
    public active = true;
    process$: Observable<fromShared.Process>;
    public jobs$: Observable<Array<IContractStructure>>;
    public jobListStatus$: Observable<Array<IEntityFilter>>;
    public customers$: Observable<Array<ICustomer>>;
    public contractTypes$: Observable<fromLookups.IContractType[]>;
    public selectedStatus: IEntityFilter;

    @ViewChild(ContractStructurePresentersComponent, { static: true })
    cspc: ContractStructurePresentersComponent;

    errors$: Observable<string[]>;
    selectedError$: Observable<IShowErrors>;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);

    constructor(
        private customerJobStore: Store<fromCJ_r.State>,
        @Inject(LoggingService) private log: LoggingService,
        private lookupsStore: Store<fromLookups.LookupState>,
        private store: Store<fromUser.State>,
        private errorStore: Store<fromShared.Errors.State>
    ) {}

    ngOnInit() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.jobs$ = this.customerJobStore.pipe(
            select(fromCJ_r.getCustomerJobs),
            filter(x => !!x)
        );

        this.jobListStatus$ = this.customerJobStore.pipe(
            select(fromCJ_r.getEntityFilter),
            filter(x => !!x)
        );

        this.customers$ = this.customerJobStore.pipe(
            select(fromCJ_r.getCustomers),
            filter(x => !!x)
        );

        this.contractTypes$ = this.lookupsStore.pipe(
            select(fromLookups.getContractTypes)
        );

        this.errors$ = this.store.pipe(select(fromCJ_r.getCustomerJobErrors));

        this.selectedError$ = this.errorStore.pipe(
            select(fromShared.Errors.getShowErrors)
        );
    }

    ngAfterViewInit() {
        // this.customerJobStore.dispatch(new LoadContractTypes());

        this.customerJobStore.dispatch(new LoadEntityFilter());

        this.customerJobStore.dispatch(new LoadCustomers());
        this.store.dispatch(new fromLookups.LoadContractTypes());

        this.customerJobStore.dispatch(
            new LoadCustomerJobs([], {
                FilterID: 1,
                FilterDesc: null,
                FilterEntity: null
            })
        );

        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });

        this.cspc.selectStatus
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.selectedStatus = value;
                    this.customerJobStore.dispatch(
                        new LoadCustomerJobs([], value)
                    );
                }
            });

        this.cspc.selectCustomer
            .pipe(
                takeWhile(_ => this.active),
                withLatestFrom(this.jobListStatus$)
            )
            .subscribe(([customers, jobStatuses]) => {
                if (customers != null) {
                    if (this.selectedStatus == null) {
                        this.selectedStatus = jobStatuses[0];
                    }

                    this.customerJobStore.dispatch(
                        new LoadCustomerJobs(customers, this.selectedStatus)
                    );
                }
            });

        this.cspc.resetFilters
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                this.customerJobStore.dispatch(
                    new LoadCustomerJobs(value, {
                        FilterID: 1,
                        FilterDesc: null,
                        FilterEntity: null
                    })
                );
            });

        this.cspc.rowUpdate
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.customerJobStore.dispatch(
                        new UpdateContractStructure(value)
                    );
                }
            });

        this.cspc.resetData
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                this.customerJobStore.dispatch(new Reset());
            });
    }

    ngOnDestroy() {
        this.active = false;
    }

    public onResetData() {
        this.customerJobStore.dispatch(new Reset());
    }

    OnShowError(event) {
        this.ShowError.next(event);
    }

    onLoadJobListStatus($event) {
        this.customerJobStore.dispatch(new LoadEntityFilter());
    }

    onLoadCustomerJobs($event) {
        this.selectedStatus = $event.Status;
        this.customerJobStore.dispatch(
            new LoadCustomerJobs($event.Customers, $event.Status)
        );
    }
}
